export default function() {
  return (array = [], type) => array.filter(item => item[type]).length;
}



// WEBPACK FOOTER //
// ./src/app/filters/Count.js